import { BreadcrumbGroupProps } from '@amzn/awsui-components-core';
import { createItemMetadata, updateItemMetadata } from 'src/utilities/ItemMetadata';
import { v4 as uuidv4 } from 'uuid';
import HelpPanelConfiguration from '../side-panel-config/SidePanelConfiguration';
import { DEFAULT_SIDE_PANEL_DETAILS } from '../homepage-manage/HomePageManagementUtils';
import { TeamPageStep1 } from './steps/TeamPageStep1';
import { TeamPageStep2 } from './steps/TeamPageStep2';
import { FinTechTeams, TeamPageWizard } from './TeamManagementModel';

// Default state for team page content
export const getTeamContentDefaultState = (alias: string): FinTechTeams => ({
  id: uuidv4(),
  enableTeamInfoTabs: true,
  teams: [],
  sidePanelDetails: DEFAULT_SIDE_PANEL_DETAILS,
  itemMetadata: createItemMetadata(alias)
});

// Default state for team page wizard
export const getTeamWizardContentDefaultState = (alias: string): TeamPageWizard => ({
  id: uuidv4(),
  teamManagement: [],
  teamPageDetailsAndWidgets: {
    enableTeamInfoTabs: true,
    teams: []
  },
  infoPanelPageConfiguration: {
    sidePanelDetails: DEFAULT_SIDE_PANEL_DETAILS
  },
  itemMetadata: createItemMetadata(alias)
});

// Convert team page entity to wizard format
export const teamPageContentAPIToWizard = (teamPageEntity: FinTechTeams, userAlias: string): TeamPageWizard => ({
  id: teamPageEntity.id,
  teamManagement: teamPageEntity.teams.map((team) => ({
    id: team.id,
    isNewTeam: false,
    teamName: team.teamName
  })),
  teamPageDetailsAndWidgets: {
    enableTeamInfoTabs: teamPageEntity.enableTeamInfoTabs,
    teams: teamPageEntity.teams.map((team) => ({
      id: team.id,
      teamName: team.teamName,
      teamIntroductionVideoUrl: team.teamIntroductionVideoUrl,
      teamOverView: team.teamOverView,
      teamWelcomeDetails: team.teamWelcomeDetails.map((welcomeDetail) => ({
        id: welcomeDetail.id,
        displayText: welcomeDetail.displayText,
        link: welcomeDetail.link,
        description: welcomeDetail.description,
        pointOfContact: welcomeDetail.pointOfContact === '' ? null : welcomeDetail.pointOfContact
      }))
    }))
  },
  infoPanelPageConfiguration: {
    sidePanelDetails: teamPageEntity.sidePanelDetails
  },
  itemMetadata: updateItemMetadata(userAlias, teamPageEntity.itemMetadata)
});

// Convert team page wizard to entity format
export const teamPageContentWizardToAPI = (teamPageWizard: TeamPageWizard): FinTechTeams => ({
  id: teamPageWizard.id,
  enableTeamInfoTabs: teamPageWizard.teamPageDetailsAndWidgets.enableTeamInfoTabs,
  teams: teamPageWizard.teamPageDetailsAndWidgets.teams,
  sidePanelDetails: teamPageWizard.infoPanelPageConfiguration.sidePanelDetails,
  itemMetadata: teamPageWizard.itemMetadata
});

export const TeamPageWizardSteps: any[] = [
  {
    title: 'Manage Teams',
    description: '',
    stateKey: 'manageTeams',
    StepContent: TeamPageStep1,
    isOptional: false
  },
  {
    title: 'Team Page Widgets',
    description: '',
    stateKey: 'teamPageDetails',
    StepContent: TeamPageStep2,
    isOptional: false
  },
  {
    title: 'Side Panel Details',
    description: '',
    stateKey: 'helpPanelConfiguration',
    StepContent: HelpPanelConfiguration,
    isOptional: false
  }
];
